export default "__VITE_ASSET__CuwmGv2a__";